const es = {
  // Navbar
  'nav.home': 'Inicio',
  'nav.catalog': 'Catálogo',
  'nav.import': 'Importación',
  'nav.featured': 'Destacados',
  'nav.contact': 'Contacto',
  'nav.cta': 'Importar mi coche',

  // Hero
  'hero.badge': 'Importación Premium · de toda europa',
  'hero.title1': 'Importamos',
  'hero.title2': 'el',
  'hero.title3': 'coche',
  'hero.title4': '',
  'hero.title5': 'que\u00a0quieras',
  'hero.subtitle': 'Vehículos exclusivos desde Alemania, Bélgica, Países Bajos y más. Con gestión integral y máxima seguridad.',
  'hero.cta.catalog': 'Ver catálogo',
  'hero.cta.quote': 'Solicitar importación',
  'hero.badge.certified': 'Certificados',
  'hero.badge.approved': 'Homologados',
  'hero.badge.guaranteed': 'Garantizados',
  'hero.badge.insured': 'Asegurados',

  // WhyUs
  'whyus.label': 'Nuestras ventajas',
  'whyus.title1': '¿Por qué elegir',
  'whyus.title2': 'ZS Cars Import?',
  'whyus.subtitle': 'Importación vehículos premium con total transparencia y profesionalidad. Flexibilidad en nuestros servicios, pregúntanos sin compromisos.',
  'whyus.more': 'Saber más',
  'whyus.b1.title': 'Importación Personalizada',
  'whyus.b1.desc': 'Encontramos exactamente el vehículo que buscas, con las especificaciones que deseas, en cualquier mercado de Europa.',
  'whyus.b2.title': 'Vehículos Certificados',
  'whyus.b2.desc': 'Cada vehículo pasa por una inspección técnica exhaustiva antes de la compra. Historial verificado y sin sorpresas.',
  'whyus.b3.title': 'Gestión integral del proceso',
  'whyus.b3.desc': 'Nos encargamos de toda la documentación, coordinación y trámites necesarios para la importación del vehiculo.',
  'whyus.b4.title': 'Transporte seguro y coordinado',
  'whyus.b4.desc': 'Organizamos el traslado del vehículo desde origen con seguimiento y planificación durante todo el proceso.',
  'whyus.b5.title': 'Matriculación y trámites',
  'whyus.b5.desc': 'Gestionamos la matriculación en España y documentación. Entrega lista para circular.',
  'whyus.b6.title': 'Atención VIP',
  'whyus.b6.desc': 'Asesor personal dedicado durante todo el proceso. Disponible 24/7 para resolver cualquier duda.',

  // ImportProcess
  'process.label': 'Proceso de importación',
  'process.title1': 'Simple, seguro y',
  'process.title2': 'transparente',
  'process.subtitle': 'Gestionamos todo el proceso de importación de principio a fin. Tú solo tienes que elegir tu coche.',
  'process.cta': 'Iniciar mi importación',
  'process.s1.title': 'Encuentra tu coche ideal',
  'process.s1.desc': 'Cuéntanos qué vehículo sueñas tener. Marca, modelo, año, equipamiento. Nuestros expertos buscan en toda Europa.',
  'process.s1.detail': 'Búsqueda personalizada en más de 50 mercados internacionales',
  'process.s2.title': 'Verificamos y negociamos',
  'process.s2.desc': 'Inspeccionamos el vehículo in situ, verificamos el historial completo y negociamos el mejor precio en tu nombre.',
  'process.s2.detail': 'Inspección técnica de 150 puntos + historial verificado',
  'process.s3.title': 'Nos ocupamos de toda la gestión',
  'process.s3.desc': 'Coordinamos el transporte, la documentación y todos los trámites necesarios hasta la llegada del vehículo a España.',
  'process.s3.detail': 'Seguimiento completo de la operación',
  'process.s4.title': 'Entrega llave en mano',
  'process.s4.desc': 'Tu vehículo llega matriculado y listo para circular. Lo entregamos donde tú quieras.',
  'process.s4.detail': 'Entrega en tu domicilio en toda España',

  // FeaturedCars
  'featured.label': 'Coches destacados',
  'featured.speed': 'Velocidad máx.',
  'featured.power': 'Potencia',
  'featured.accel': '0-100 km/h',
  'featured.origin': 'Origen',
  'featured.cta': 'Consultar este vehículo',
  'featured.whatsapp': 'Hola, estoy interesado en el',
  'featured.whatsapp2': '¿Podéis darme más información?',

  // Catalog
  'catalog.label': 'Vehículos disponibles',
  'catalog.title1': 'Catálogo',
  'catalog.title2': 'Exclusivo',
  'catalog.subtitle': 'Vehículos premium seleccionados y verificados, listos para importar.',
  'catalog.filter.brand': 'Marca',
  'catalog.filter.type': 'Tipo',
  'catalog.filter.fuel': 'Combustible',
  'catalog.filter.trans': 'Cambio',
  'catalog.filter.price': 'Precio',
  'catalog.filter.all': 'Todos',
  'catalog.filter.sport': 'Deportivo',
  'catalog.filter.suv': 'SUV',
  'catalog.filter.sedan': 'Berlina',
  'catalog.filter.gasoline': 'Gasolina',
  'catalog.filter.hybrid': 'Híbrido',
  'catalog.filter.electric': 'Eléctrico',
  'catalog.filter.auto': 'Automático',
  'catalog.filter.manual': 'Manual',
  'catalog.empty': 'No hay vehículos con estos filtros',
  'catalog.cta': 'Consultar vehículo',
  'catalog.whatsapp': 'Hola, estoy interesado en el',
  'catalog.whatsapp2': '¿Podéis darme más información?',

  // Contact
  'contact.label': 'Contacto',
  'contact.title1': 'Importa tu coche',
  'contact.title2': 'de ensueño',
  'contact.subtitle': 'Cuéntanos qué vehículo quieres y te preparamos una cotización personalizada sin compromiso. Respondemos en menos de 24 horas.',
  'contact.whatsapp': 'WhatsApp',
  'contact.email': 'Email',
  'contact.location': 'Ubicación',
  'contact.location.value': 'Marbella, Málaga',
  'contact.schedule': 'Horario',
  'contact.schedule.value': 'Lun-Vie 9:00-19:00',
  'contact.whatsapp.cta': 'Contactar por WhatsApp',
  'contact.form.title': 'Solicitar importación',
  'contact.form.name': 'Nombre',
  'contact.form.name.ph': 'Tu nombre',
  'contact.form.phone': 'Teléfono',
  'contact.form.phone.ph': '+34 600 000 000',
  'contact.form.email': 'Email',
  'contact.form.email.ph': 'tu@email.com',
  'contact.form.model': 'Modelo deseado',
  'contact.form.model.ph': 'Ej: BMW M4, Mercedes C63 AMG...',
  'contact.form.budget': 'Presupuesto',
  'contact.form.budget.ph': 'Selecciona tu presupuesto',
  'contact.form.message': 'Mensaje',
  'contact.form.message.ph': 'Cuéntanos más detalles sobre el vehículo que buscas...',
  'contact.form.submit': 'Quiero importar mi coche',
  'contact.form.sending': 'Enviando...',
  'contact.form.new': 'Nueva solicitud',
  'contact.success.title': '¡Solicitud enviada!',
  'contact.success.desc': 'Hemos recibido tu solicitud. Nuestro equipo se pondrá en contacto contigo en menos de 24 horas.',
  'contact.budget.1': 'Menos de 30.000€',
  'contact.budget.2': '30.000€ - 60.000€',
  'contact.budget.3': '60.000€ - 100.000€',
  'contact.budget.4': '100.000€ - 150.000€',
  'contact.budget.5': 'Más de 150.000€',

  // Testimonials
  'testimonials.label': 'Testimonios',
  'testimonials.title1': 'Lo que dicen',
  'testimonials.title2': 'nuestros clientes',
  'testimonials.subtitle': 'Más de 500 clientes satisfechos avalan nuestra trayectoria.',
  'testimonials.badge1': '4.9/5 valoración media',
  'testimonials.badge2': 'Empresa verificada',
  'testimonials.badge3': '+500 clientes satisfechos',
  'testimonials.badge4': '8 años de experiencia',
  'testimonials.cta.pre': '¿Listo para unirte a nuestros clientes satisfechos?',
  'testimonials.cta': 'Solicitar mi importación',

  // Footer
  'footer.brand.desc': 'Importamos vehículos premium y deportivos desde toda Europa con total transparencia y seguridad.',
  'footer.nav.title': 'Navegación',
  'footer.services.title': 'Servicios',
  'footer.contact.title': 'Contacto',
  'footer.service1': 'Importación personalizada',
  'footer.service2': 'Transporte de vehículos propios',
  'footer.service3': '',
  'footer.service4': 'Gestión de documentación',
  'footer.service5': 'Atención VIP',
  'footer.rights': '© 2026 ZS Cars Import. Todos los derechos reservados.',
  'footer.privacy': 'Política de privacidad',
  'footer.legal': 'Aviso legal',
  'footer.cookies': 'Cookies',

  // Simulator
  'simulator.label': 'Calculadora de ahorro',
  'simulator.title1': '¿Cuánto ahorras',
  'simulator.title2': 'importando?',
  'simulator.subtitle': 'Calcula el ahorro real de importar tu coche desde Alemania frente a comprarlo en España. Precios orientativos basados en mercado real.',
  'simulator.configure': 'Configura tu simulación',
  'simulator.car': 'Selecciona el modelo',
  'simulator.price.de': 'Precio en Alemania',
  'simulator.price.es': 'Precio en España',
  'simulator.breakdown': 'Desglose de costes de importación',
  'simulator.item.price': 'Precio del vehículo (Alemania)',
  'simulator.item.transport': 'Gastos de transporte',
  'simulator.item.transport.sub': 'desde',
  'simulator.item.management': 'Gestión y trámites',
  'simulator.item.taxes': 'Tasas e impuestos',
  'simulator.item.taxes.sub': 'Variables según vehículo',
  'simulator.item.zscars': 'Tarifa fija ZS Cars',
  'simulator.total.import': 'Total estimado importado en España',
  'simulator.total.spain': 'Precio aproximado en España',
  'simulator.total.import.approx': 'aprox.',
  'simulator.cta': 'Quiero importar este coche',
  'simulator.savings.label': 'Tu ahorro estimado',
  'simulator.savings.desc': 'Aproximadamente un {{pct}}% menos que en España',
  'simulator.import.cost': 'Coste de importación',
  'simulator.spain.cost': 'Precio en España',
  'simulator.stat.days': 'Días aprox.',
  'simulator.stat.certified': 'Certificado',
  'simulator.stat.origin': 'Origen',
  'simulator.disclaimer': 'Los precios son estimaciones orientativas basadas en datos de mobile.de y concesionarios españoles. Los costes reales pueden variar según equipamiento, año, kilometraje y tipo de cambio. Consulta con nuestro equipo para una cotización exacta y personalizada.',
  'simulator.savings.approx': 'aprox.',
  'simulator.note': 'Los costes de transporte, impuestos y matriculación pueden variar según el vehículo, emisiones CO₂ y normativa vigente.',

  // CustomOrderCTA
  'customcta.label': 'Búsqueda personalizada',
  'customcta.title': '¿El vehículo que buscas no aparece en nuestro catálogo?',
  'customcta.subtitle': 'Trabajamos bajo pedido y búsqueda personalizada. Contáctanos y encontraremos el coche perfecto para ti.',
  'customcta.feat1': 'Sin compromiso',
  'customcta.feat2': 'Toda Europa',
  'customcta.feat3': 'Respuesta en 24h',
  'customcta.feat4': 'Atención VIP',
  'customcta.btn.whatsapp': 'Escríbenos por WhatsApp',
  'customcta.btn.contact': 'Formulario de contacto',
  'customcta.trust': 'Más de 500 clientes satisfechos · 8 años de experiencia · Marbella, España',
  'customcta.whatsapp': 'Hola, busco un vehículo que no aparece en vuestro catálogo. ¿Podéis ayudarme con una búsqueda personalizada?',

  // SEO
  'seo.title': 'ZS Cars Import | Importación de coches',
  'seo.description': 'ZS Cars Import — Importamos vehículos exclusivos desde Alemania, Bélgica y Países Bajos. BMW, Mercedes, Porsche, Audi con gestión aduanera completa y entrega llave en mano.',
};

export default es;